import { Box, ListItem, ListItemText } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import { useAtomValue } from 'jotai';
import PhoneNumberDisplay from '../../common/components/PhoneNumberDisplay';
import { currentContextAtom, userAtom } from '../../state';
import { PRIVACY_SETTING_WORDING } from './PrivacySettingSelect';

export enum PhoneType {
  MOBILE = 'MOBILE',
  LANDLINE = 'LANDLINE'
}
interface PhoneContactInformationDisplayProps {
  phoneType: PhoneType;
}

export default function PhoneContactInformationDisplay({ phoneType }: PhoneContactInformationDisplayProps): React.JSX.Element {
  const { t } = useTranslation(['common', 'settings']);
  const user = useAtomValue(userAtom);
  const { realm } = useAtomValue(currentContextAtom);

  const { phoneNumber, privacySetting } = useMemo(() => {
    if (phoneType === PhoneType.LANDLINE) {
      return {
        phoneNumber: user.contactInformation?.landlinePhone,
        privacySetting: user.contactInformation?.landlinePrivacySetting,
      };
    }

    return {
      phoneNumber: user.contactInformation?.mobilePhone,
      privacySetting: user.contactInformation?.mobilePrivacySetting,
    };
  }, [phoneType, user]);

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 1,
        flexDirection: {
          xs: 'column',
          sm: 'row',
        },
      }}
    >
      <Box
        sx={{
          width: '50%',
          mb: {
            xs: 2,
            sm: 0,
          },
        }}
      >
        <ListItem>
          <ListItemText
            sx={{
              display: 'flex',
              flexDirection: 'column-reverse',
            }}
            primary={(
              <PhoneNumberDisplay phoneNumber={phoneNumber} />
            )}
            secondary={t('common:number')}
          />
        </ListItem>
      </Box>
      <Box sx={{ width: '50%' }}>
        <ListItem>
          <ListItemText
            sx={{
              display: 'flex',
              flexDirection: 'column-reverse',
            }}
            primary={
              privacySetting
                ? t(PRIVACY_SETTING_WORDING[privacySetting][realm]!)
                : '-'
            }
            secondary={t('settings:information_visible_to')}
          />
        </ListItem>
      </Box>
    </Box>
  );
}
